import React from 'react';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import Refresh from '@material-ui/icons/Refresh';
import LinkIcon from '@material-ui/icons/Link';
import { ActionMenu } from '../../ActionMenu';
import {
  KubernetesActionMenuItems,
  KubernetesAction,
  KubernetesActionType,
  KubernetesResourceType,
} from './types';
import {
  MenuItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';

interface KubernetesMenuProps {
  handleActionClick: (
    action: KubernetesActionType,
    service: KubernetesResourceType,
  ) => void;
  handleMenuClose: () => void;
  handleOpenConnection: () => void;
  menuPosition: { mouseX: number | null; mouseY: number | null };
  service: KubernetesResourceType;
}

const useStyles = makeStyles({
  truncatedText: {
    display: 'block',
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const getMenuItems = (
  service: KubernetesResourceType,
): KubernetesActionMenuItems[] => {
  switch (service) {
    case 'resources': {
      return [
        {
          action: KubernetesAction.START,
          service: 'resources',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start Resources',
          disabled: false,
        },
        {
          action: KubernetesAction.STOP,
          service: 'resources',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop Resources',
          disabled: false,
        },
        {
          action: KubernetesAction.RESTART,
          service: 'resources',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart Resources',
          disabled: false,
        },
      ];
    }
    default:
      return [];
  }
};

export const KubernetesActionMenu: React.FC<KubernetesMenuProps> = ({
  handleActionClick,
  handleMenuClose,
  handleOpenConnection,
  menuPosition,
  service,
}) => {
  const menuItems = getMenuItems(service);
  const classes = useStyles();

  return (
    <ActionMenu<{
      action: KubernetesActionType;
      service: KubernetesResourceType;
    }>
      handleActionClick={handleActionClick}
      handleMenuClose={handleMenuClose}
      menuPosition={menuPosition}
      menuItems={menuItems}
      additionalMenuItems={[
        <MenuItem key="connect-kubernetes" onClick={handleOpenConnection}>
          <ListItemIcon>
            <LinkIcon fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText>
            <span className={classes.truncatedText}>Connect to Kubernetes</span>
          </ListItemText>
        </MenuItem>,
      ]}
    />
  );
};
